<template>
    <div class='bar'>
        <div class="navBody">
            <Menubar :model="MenubarData" />
            <div class="logoDemo">
                <img 
                    :src="require('../assets/storium.svg')"
                    alt="logo"
                    width="140px"
                />
                <!-- <h2 style="align-self: flex-end; margin: 0;">DEMO</h2> -->
            </div>
        </div>
    </div>
</template>
  
<script>
import Menubar from 'primevue/menubar';

export default {
    name: 'demoMenu',
    components: {
        Menubar
    },
    data() {
        return {
            visible: false,
            showError: false,
            MenubarData: [
                {
                    label: 'Töölaud',
                    icon: 'pi pi-home',
                    command: () => {
                        this.$router.push({ name: 'workboard' });
                    }
                },
                {
                    label: 'Poe tellimused',
                    icon: 'pi pi-star',
                    command: () => {
                        this.$router.push({ name: 'orders' });
                    }
                },
                {
                    label: 'Poe tooted',
                    icon: 'pi pi-box',
                    command: () => {
                        this.$router.push({ name: 'products' });
                    }
                },
                {
                    label: 'Poe seaded',
                    icon: 'pi pi-wrench',
                    command: () => {
                        this.$router.push({ name: 'shopSettings' });
                    }
                }
            ]
        };
    },
    computed: {
      
    },
    methods: {
        
    },
    created() {
        

    },
    mounted() {
      // Lifecycle hook - called after the component is mounted to the DOM
    
    },
    updated() {
      // Lifecycle hook - called after a data change causes the DOM to re-render
    
    },
  };
</script>
<style>
.p-menubar {
    --p-menubar-border-color: white;
    width: 100%;
}
@media (max-width: 720px) {
    
}
@media (max-width: 575px) {
    
}
@media (max-width: 420px) {
    
}
</style>
<style scoped>
.errMsg {
    margin-top: 5px;
}
.bar {
    position: relative;
    z-index: 1100;
    width: 100%;
    padding-bottom: 10px;
    padding-top: 10px;
    position: fixed;
    top: 0;
    background: white;
    -webkit-box-shadow: 0px 2px 13px -8px rgba(0,0,0,0.2);
    -moz-box-shadow: 0px 2px 13px -8px rgba(0,0,0,0.2);
    box-shadow: 0px 2px 13px -8px rgba(0,0,0,0.2);
    display: none;
}
.bar h2 {
    margin: 0;
    margin-top: 0px;
    color: rgb(173, 194, 214);
    font-size: 24px;
    height: fit-content;
    height: 25px;
}
.bar img {
    margin-left: -2px;
}
.navBtns {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    display: flex;
    column-gap: 10px;
}
.logoDemo {
    position: absolute;
    left: 60px;
    display: flex; column-gap: 5px;
}
.navBody {
    position: relative;
    width: 100%;
    display: flex;
}
@media (max-width: 1470px) {
    
}
@media (max-width: 620px) {
    
}
@media (max-width: 500px) {
    .bar {
        display: inline;
    }
}
</style>